import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";
import {kSystemIcons} from "../../../constants/icons";

export default function CoursesScreenInfoDialog({open, handleClose}) {
    // Used through app screen headers to handle info about current
    // screen concept

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogMediumStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.book}
                                        title={"Cours et exercices"} />
                {/** CONTENT */}
                <div className={"w-full flex flex-col justify-start items-start p-[24px]"}>
                    <span className={"font-bold text-[20px] text-white -mt-[6px]"}>
                       {"Tu cherches à réviser un chapitre vu en classe\u00A0?"}
                    </span>
                    <span className={"font-normal text-[14px] text-greyLight9 mt-[12px]"}>
                        {"Dans cours et exercices, retrouve tous les savoir-faire fondamentaux au programme du collège regroupés par chapitre."}
                    </span>
                </div>
            </div>
        </Modal>
    );
}